import { z } from "zod";

export const cancelNegotiationSchema = z.object({
  cancel_reason: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type CancelNegotiationValidationSchema = z.infer<typeof cancelNegotiationSchema>;
